import client from '../../utils/client';
import { endPoints } from '../../constants/configuration';

// export const getCreativeApi = async ({ tenantId, authToken, userId, params, payload }) => {
//   try {
//     const { data } = await client().post(
//       endPoints.creative + '?list=all',payload, {
//         params,
//       headers: {
//         common: {
//           'tai_tenant': parseInt(tenantId),
//           'tai_token': authToken,
//           'tai_user': userId,
//         }
//       }
//     }
//     );
//     return data;
//   } catch (error) {
//     // get axios errors from error.response
//     console.log(error);
//     throw error;
//   }
// }

export const getCreativeNameListApi = async ({ tenantId, authToken, userId, params }) => {
  // console.log(endPoints);
  try {
    const { data } = await client().get(`${endPoints.beki}${endPoints.creative}`, {
      params,
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postCreativeApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(`${endPoints.beki}${endPoints.creative}`,payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postCampaignApi = async ({ tenantId, authToken, userId, params, payload }) => {
  try {
    const { data } = await client().post(`${endPoints.beki}${endPoints.campaign}`,payload, {
      params,
      headers: {
        common: {
          'tai_tenant': parseInt(tenantId),
          'tai_token': authToken,
          'tai_user': userId,
        }
      }
    }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
}

export const postGlobalCreativeListApi = async ({
  tenantId,
  authToken,
  userId,
  params,
  payload
}) => {
  try {
    // console.log(offset, "API");
    const { data } = await client().post(
      `${endPoints.beki}${endPoints.creative}`,
      payload,
      {
        params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};